/**
 * VoiceForge — Hugging Face Xet bucket for app durable data (Binder pattern).
 *
 *   hf sync ./data hf://buckets/copperscout1/voiceforge-user
 *
 * Local mirror: voiceforge/data/
 * Sync: npm run hf:sync | hf:pull
 *
 * One shared app bucket only — never create voiceforge-u-* per-user buckets.
 * Multi-tenant isolation (if needed) = path prefixes under ./data/user/{key}/.
 */

export const VOICEFORGE_HF_BUCKET = "copperscout1/voiceforge-user";
export const VOICEFORGE_HF_BUCKET_URI = `hf://buckets/${VOICEFORGE_HF_BUCKET}`;

/** Local shelves under ./data (mirrored to the bucket). */
export const VOICEFORGE_DATA_SHELVES = [
  "takes",
  "uploads",
  "exports",
  "meta",
  "user",
  "refs",
] as const;

export type VoiceforgeDataShelf = (typeof VOICEFORGE_DATA_SHELVES)[number];

export function voiceforgeBucketSyncPushCmd(localDir = "./data"): string {
  return `hf sync ${localDir} ${VOICEFORGE_HF_BUCKET_URI}`;
}

export function voiceforgeBucketSyncPullCmd(localDir = "./data"): string {
  return `hf sync ${VOICEFORGE_HF_BUCKET_URI} ${localDir}`;
}
